import PostGameHome from './PostGameHome';

export default PostGameHome;
